module.exports = __webpack_public_path__ + "r-v3/img/ico_participant_invite_white.17db634b.svg";